import useInView from './hooks/useInView';
import './Tour.scss';

const Tour = () => {
    const [ref, isVisible] = useInView();
    return (
        <div
            ref={ref}
            className={`tour-container ${isVisible ? "fade-in" : ""}`}>
            <div className='tour-header'>
                <div className='tour-logo'>
                    <img src="dates.webp" alt="titre tour" />
                </div>
            </div>
            <div className='tour-carousel'>
                <div className='tour-slide'>
                    <div className='tour-content'>
                        <div className='date-container'>
                            <ul>
                                <li>
                                    <span> 13/02/26 </span> <br /> <span>Chez Maurice</span>  <br /> Live <br />
                                    Nantes <br />
                                    <div className="map-container">
                                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2709.6837774772243!2d-1.5544941235966538!3d47.22276941440425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4805efd07e6290d5%3A0x61e2a0021346dbc8!2sChez%20Maurice!5e0!3m2!1sen!2sfr!4v1766858557446!5m2!1sen!2sfr"></iframe>                                    
                                        </div>
                                </li>
                                {/* <li>
                                    <span> 12/10/25 </span> <br /> <span>Comme à la Radio</span>  <br /> Live <br />
                                    Nantes <br />
                                    <div className="map-container">
                                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2709.8864061636577!2d-1.5638173235968174!3d47.2188049146762!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4805ed623474eef9%3A0xaa0223af9e477efb!2sComme%20%C3%80%20La%20Radio%20Disques!5e0!3m2!1sen!2sfr!4v1758892448150!5m2!1sen!2sfr"></iframe>
                                    </div>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                    {/* <div className='tour-content'>
                        <div className='date-container'>
                            <ul>
                                <li>
                                    <span> 12/10/25 </span> <br /> <span>Comme à la Radio</span>  <br /> Live Session Filmée <br />
                                    Nantes <br />
                                    <div className="map-container">
                                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2710.009378242848!2d-1.5635919999999996!3d47.
                                2163988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4805ededddcb9b57%3A0xbd673f559daff312!2sComme%20%C3%8
                                0%20La%20Radio%20Hi-Fi!5e0!3m2!1sen!2sfr!4v1757612171245!5m2!1sen!2sfr">
                                        </iframe>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div> */}
                    {/* <div className='tour-content'>
                        <div className='date-container'>
                            <ul>
                                <li>
                                    <span> 12/10/25 </span> <br /> <span>Comme à la Radio</span>  <br /> Live Session Filmée <br />
                                    Nantes <br />
                                    <div className="map-container">
                                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2710.009378242848!2d-1.5635919999999996!3d47.
                                2163988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4805ededddcb9b57%3A0xbd673f559daff312!2sComme%20%C3%8
                                0%20La%20Radio%20Hi-Fi!5e0!3m2!1sen!2sfr!4v1757612171245!5m2!1sen!2sfr">
                                        </iframe>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>

    );
};

export default Tour;